import React, { Component } from 'react';

interface IMenuDescriptionIconProps {
    iconSrc: string;
}

export class MenuDescriptionIcon extends Component<IMenuDescriptionIconProps, any> {
    public render() {
        return <div style={{ height: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={this.props.iconSrc} />
        </div>;
    }
}
